
import { 
    HORSE_RACE_UPDATE_RECEIVED,
    HORSE_RACE_UPDATE_SUBSCRIBED,
    HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS,
    HORSE_RACE_UPDATE_FALLBACK_TO_POLLING,
    HORSE_RACE_UPDATE_CONNECT_ERROR,
    HORSE_RACE_UPDATE_CONNECT,
    HORSE_RACE_UPDATE_DISCONNECTED,
    HORSE_RACE_UPDATE_DISCONNECTING
} from '../actions/raceUpdate'

const initState = {
    raceUpdates: [],
    subscribedTopics: [],
    failedSubscriptionAttempts: 0,
    pollFallbackEnabled: false,
    intentionalMqttClose: false
}

export default (state=initState,  action) =>  {

    switch(action.type) {
        case HORSE_RACE_UPDATE_RECEIVED: return {
            ...state, 
            raceUpdates: [ action.data, ...state.raceUpdates]
        }
        case HORSE_RACE_UPDATE_SUBSCRIBED: return {
            ...state,
            subscribedTopics: [...state.subscribedTopics, ...action.data],
            pollFallbackEnabled: false,
            failedSubscriptionAttempts: 0
        }
        case HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS: return {
            ...state,
            subscribedTopics: []
        }
        case HORSE_RACE_UPDATE_CONNECT_ERROR: return {
            ...state,
            failedSubscriptionAttempts: action.failedCount,
            intentionalMqttClose: false
        }         
        case HORSE_RACE_UPDATE_FALLBACK_TO_POLLING: return {
            ...state,
            pollFallbackEnabled: true
        }
        case HORSE_RACE_UPDATE_CONNECT: return {
            ...state,
            intentionalMqttClose: false
        }
        case HORSE_RACE_UPDATE_DISCONNECTED: return {
            ...state,
            subscribedTopics: [],
            intentionalMqttClose: true
        }
        case HORSE_RACE_UPDATE_DISCONNECTING: return {
            ...state,
            intentionalMqttClose: true
        } 
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/raceUpdate.js